import React, { useEffect, useState } from 'react';
import { Button, Col, Input, InputGroup, InputGroupAddon, Row } from 'reactstrap';
import { toast } from 'react-toastify';

import { useDispatch, useSelector } from 'react-redux';
import filterIcon from '../../../../Res/Icon/filter.png';
import CompanyAutocomplete from '../../../CompanyAutocomplete';
import LocationDetails from '../../../LocationDetails';
import { advanceLocalArray } from '../../../../actions/EpikBoxes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

const filterStatusOptions = ['All', 'Registered', 'UnRegistered'];
const filterEngineeringLockOptions = ['Enabled', 'Disabled'];
const filterDialPlanOptions = ['Unified', 'Standard'];
const filterModemOptions = ['Nimbelink', 'Quectel', 'legacy'];
const filterObject = {
  type: 'Company',
  value: '',
};
const roleArray = ['superAdmin', 'supportEngineer', 'companyGroupAdmin', 'companyGroupManager'];

const AdvanceSearchBody = React.memo(
  ({ user, companies, locations, companyGroupDropdownList, advanceList }) => {
    const advanceFilters = useSelector(state => state.UIState.epikBoxes.advanceFilters);
    const [filterList, setFilterList] = useState([filterObject]);

    const dispatch = useDispatch();
    const [statusValue, setStatusValue] = useState();

    const onOptionSelect = (key, el, index) => {
      const newFilterList = JSON.parse(JSON.stringify(filterList));
      const initialDialPlanItem = filterDialPlanOptions[0];
      const initialModemItem = filterModemOptions[0];
      const initialStatusItem = filterStatusOptions[0];
      const initialEngineeringLockItem = filterEngineeringLockOptions[0];
      const indexItem = newFilterList[index];
      indexItem.type = key;
      switch (key) {
        case 'Modem Type':
          indexItem.value = initialModemItem;
          break;
        case 'Status':
          indexItem.value = initialStatusItem;
          break;
        case 'EngineeringLock':
          indexItem.value = initialEngineeringLockItem;
          break;
        case 'DialPlan':
          indexItem.value = initialDialPlanItem;
          break;
        default:
          break;
      }
      setFilterList(newFilterList);
    };
    // eslint-disable-next-line consistent-return
    const onCompanyFilter = (e, index) => {
      const { suggestion } = e;
      const newFilterList = JSON.parse(JSON.stringify(filterList));

      if (e.value) {
        newFilterList[index].value = suggestion._id;
        newFilterList[index].name = suggestion.name;
      } else {
        newFilterList[index].value = '';
        newFilterList[index].name = '';
      }
      setFilterList(newFilterList);
    };
    const onInputChange = (e, index) => {
      const { type, value: listValue } = filterList[index];
      const { value, name } = e.target;
      const newFilterList = JSON.parse(JSON.stringify(filterList));
      if (type === 'Date Range') {
        const obj = listValue || {};
        obj[name] = value;
        newFilterList[index].value = obj;

        setFilterList(newFilterList);
      } else if (type === 'EngineeringLock') {
        newFilterList[index].value = value;
      } else if (type === 'Status') {
        setStatusValue(value); 
        let val = value;
        if (value === filterStatusOptions[1]) {
          val = 'Online';
        } else if (value === filterStatusOptions[2]) {
          val = 'Offline';
        }
        newFilterList[index].value = val;

      } else {
        newFilterList[index].value = value;
      }

      setFilterList(newFilterList);
    };

    // eslint-disable-next-line no-shadow
    const renderSwitch = index => {
      const { value, type, name } = filterList[index];
      switch (type) {
        case 'Company':
          return (
            companies.docs && (
              <>
                <CompanyAutocomplete
                  className="testing-filter"
                  placeholder="Filter"
                  name="company"
                  searchTerm={name || ''}
                  companies={companies.docs}
                  onChange={e => onCompanyFilter(e, index)}
                />
                {/* {locationStatus && (
                <Col md={{ size: 4 }}>
                  <LocationDetails
                    boxesLocation
                    selectLocation={locationFilter}
                    locations={locations}
                  />
                </Col>
              )} */}
              </>
            )
          );
        case 'Modem Type':
          return (
            <Input
              type="select"
              style={{ marginBottom: '1em' }}
              name="modemType"
              value={value}
              onChange={e => onInputChange(e, index)}
            >
              {filterModemOptions.map(el => (
                <option key={el} value={el}>
                  {el}
                </option>
              ))}
            </Input>
          );
        case 'EngineeringLock':
          return (
            <Input
              type="select"
              style={{ marginBottom: '1em' }}
              name="engineeringLock"
              value={value}
              onChange={e => onInputChange(e, index)}
            >
              {filterEngineeringLockOptions.map(el => (
                <option key={el} value={el}>
                  {el}
                </option>
              ))}
            </Input>
          );
        case 'DialPlan':
          return (
            <Input
              type="select"
              style={{ marginBottom: '1em' }}
              name="DialPlan"
              value={value}
              onChange={e => onInputChange(e, index)}
            >
              {filterDialPlanOptions.map(el => (
                <option key={el} value={el}>
                  {el}
                </option>
              ))}
            </Input>
          );
        case 'Status':
          const displayValue =
            value === 'Online' ? 'Registered' :
            value === 'Offline' ? 'UnRegistered' :
            (value ?? 'All');
          return (
            <Input
              type="select"
              style={{ marginBottom: '1em' }}
              name="status"
              value={displayValue}
              onChange={e => onInputChange(e, index)}
            >
              {filterStatusOptions.map(el => (
                <option key={el} value={el}>
                  {el}
                </option>
              ))}
            </Input>
          );
        case 'Date Range':
          return (
            <InputGroup>
              <Input
                type="date"
                placeholder="Filter"
                value={value.startDate}
                name="startDate"
                onChange={e => onInputChange(e, index)}
                style={{ marginBottom: '1em' }}
              />
              <p className="mt-2">To</p>
              <Input
                type="date"
                placeholder="Filter"
                value={value.endDate}
                name="endDate"
                onChange={e => onInputChange(e, index)}
                style={{ marginBottom: '1em' }}
              />
            </InputGroup>
          );
        case 'By Group':
          return (
            <CompanyAutocomplete
              className="testing-filter"
              placeholder="Filter"
              searchTerm={name || ''}
              companies={companyGroupDropdownList.docs}
              onChange={e => onCompanyFilter(e, index)}
            />
          );
        default:
          return (
            <InputGroup>
              <Input
                type="text"
                placeholder="Filter"
                value={value}
                onChange={e => onInputChange(e, index)}
                style={{ marginBottom: '1em' }}
              />
            </InputGroup>
          );
      }
    };
    const onRemove = (el, index) => {
      const newFilterList = filterList.filter((_, i) => i !== index);
      setFilterList(newFilterList);
    };

    // eslint-disable-next-line consistent-return
    const onAdd = () => {
      const uniqueValues = new Set(filterList.map(v => v.type));
      if (uniqueValues.size < filterList.length) {
        return toast.error('You can only select one filter for each type');
      }
      setFilterList(filterList.concat(filterObject));
    };

    const onResetFilters = () => {
      setFilterList([filterObject]);
      dispatch(advanceLocalArray([]));
    };
    useEffect(() => {
      advanceList(filterList);
    }, [filterList]);

    useEffect(() => {
      if (advanceFilters.length > 0) {
        setFilterList(advanceFilters);
      }
    }, [advanceFilters]);

    return (
      <div>
        {roleArray.some(x => x === user.role) &&
          filterList.map((el, index) => {
            const { type } = el;
            return (
              <Row>
                <Col md={10} className="select-status">
                  <InputGroup style={{ marginBottom: '1em' }}>
                    <InputGroupAddon addonType="prepend" className="filter-icon-div">
                      <img src={filterIcon} className="filter-icon" alt="filter" />
                    </InputGroupAddon>
                    <Input
                      type="select"
                      className="filter-append-dropdown"
                      value={type}
                      onChange={e => onOptionSelect(e?.currentTarget.value, el, index)}
                    >
                      {user.company.companyType !== 'manufacturer' && (
                        <option key="Company" value="Company">
                          Company
                        </option>
                      )}
                      <option key="Status" value="Status">
                        Status
                      </option>
                      <option key="By Group" value="By Group">
                        By Group
                      </option>
                      <option key="Modem Type" value="Modem Type">
                        Modem Type
                      </option>
                      <option key="Date Range" value="Date Range">
                        Created On
                      </option>
                      <option key="EngineeringLock" value="EngineeringLock">
                        Engineering Lock
                      </option>
                      <option key="DialPlan" value="DialPlan">
                        DialPlan
                      </option>
                    </Input>
                  </InputGroup>
                  <>{renderSwitch(index)}</>
                </Col>
                <Col md={2}>
                  <Button outline color="danger" onClick={() => onRemove(el, index)}>
                    <FontAwesomeIcon icon={faTrash} />
                  </Button>
                </Col>
              </Row>
            );
          })}
        <Row>
          <Col md={2}>
            <Button disabled={filterList?.length === 5} outline color="primary" onClick={onAdd}>
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </Col>
          {filterList.length > 1 && (
            <Col md={4}>
              {' '}
              <Button
                disabled={filterList?.length === 5}
                outline
                color="danger"
                onClick={onResetFilters}
              >
                Reset Filters
              </Button>
            </Col>
          )}

          {filterList?.length === 5 && <p className="mt-2 bold">You can only select 5 filters</p>}
        </Row>
      </div>
    );
  },
);

export default AdvanceSearchBody;
